import React from 'react';

const Payment = props => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    {/* Generator: Sketch 51.1 (57501) - http://www.bohemiancoding.com/sketch */}
    <title>Payment decorative icon</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle id="path-1" cx={36} cy={36} r={36} />
      <rect
        id="path-3"
        x="2.72848411e-12"
        y={0}
        width="41.2329473"
        height="26.0418614"
        rx={1}
      />
      <rect
        id="path-5"
        x="-2.72848411e-12"
        y={0}
        width="41.2329473"
        height="3.25523268"
      />
    </defs>
    <g
      id="School-Onboarding"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Payment---by-credit-card"
        transform="translate(-150.000000, -605.000000)"
      >
        <g
          id="Payment-decorative-icon"
          transform="translate(150.000000, 605.000000)"
        >
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <use id="Mask" fill="#DFE1E7" xlinkHref="#path-1" />
          <g id="Group-14" mask="url(#mask-2)">
            <g transform="translate(40.674466, 32.184501) rotate(-8.000000) translate(-40.674466, -32.184501) translate(19.674466, 18.684501)">
              <g id="Rectangle-62" transform="translate(0.000000, 0.000000)">
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3" />
                </mask>
                <use id="Mask" fill="#576183" xlinkHref="#path-3" />
                <path
                  d="M-0.327057776,6.05432769 L30.0549856,6.05432769 C30.6072704,6.05432769 31.0549856,6.50204294 31.0549856,7.05432769 L31.0549856,22.5205259 C31.0549856,23.0300751 30.6718499,23.4581393 30.1654172,23.5144096 L2.70712939,26.5653305 C2.17597166,26.624348 1.69228542,26.2552959 1.6089349,25.7274093 L-1.31482074,7.21029026 C-1.40095649,6.66476384 -1.02854677,6.15270048 -0.483020349,6.06656472 C-0.431432145,6.05841922 -0.379285088,6.05432769 -0.327057776,6.05432769 Z"
                  fill="#47506B"
                  mask="url(#mask-4)"
                  transform="translate(14.778822, 16.362565) rotate(7.000000) translate(-14.778822, -16.362565) "
                />
              </g>
              <g id="Group-13" transform="translate(-0.000000, 4.340310)">
                <g id="Rectangle-62" transform="translate(-0.000000, 0.000000)">
                  <mask id="mask-6" fill="white">
                    <use xlinkHref="#path-5" />
                  </mask>
                  <use id="Mask" fill="#F0F2F6" xlinkHref="#path-5" />
                  <polygon
                    fill="#757D99"
                    opacity="0.8"
                    mask="url(#mask-6)"
                    transform="translate(14.778822, 12.022254) rotate(7.000000) translate(-14.778822, -12.022254) "
                    points="-1.49734115 1.71401745 31.0549856 1.71401745 31.0549856 19.0752584 1.75789153 22.3304911"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Group-14" mask="url(#mask-2)">
            <g transform="translate(10.000000, 27.000000)">
              <rect
                id="Rectangle-62"
                fill="#FFFFFF"
                fillRule="nonzero"
                x={0}
                y={0}
                width={41}
                height={26}
                rx={1}
              />
              <path
                d="M22.3121992,11.0245875 L39.227237,1.07456523 C39.7032701,0.794545747 40.3161718,0.953446197 40.5961913,1.42947932 C40.6865893,1.58315597 40.7342571,1.75820667 40.7342571,1.93649945 L40.7342571,25.2299442 C40.7342571,25.782229 40.2865419,26.2299442 39.7342571,26.2299442 L2.80408547,26.2299442 C2.25180072,26.2299442 1.80408547,25.782229 1.80408547,25.2299442 C1.80408547,24.8955911 1.9711866,24.5833597 2.24938527,24.3978939 L22.2645191,11.0544714 C22.280129,11.0440648 22.2960287,11.0340995 22.3121992,11.0245875 Z"
                id="Rectangle-62"
                fill="#FCFCFD"
                fillRule="evenodd"
              />
              <g
                id="Group-13"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
                transform="translate(4.000000, 4.000000)"
              >
                <rect
                  id="Rectangle-8"
                  fill="#9EA3B7"
                  x={0}
                  y={0}
                  width={26}
                  height="2.125"
                  rx={1}
                />
                <rect
                  id="Rectangle-8-Copy"
                  fill="#C6C9D5"
                  x={0}
                  y="15.9375"
                  width={13}
                  height="1.0625"
                  rx="0.53125"
                />
                <rect
                  id="Rectangle-8-Copy-2"
                  fill="#C6C9D5"
                  x={0}
                  y="13.8125"
                  width="4.33333333"
                  height="1.0625"
                  rx="0.53125"
                />
                <rect
                  id="Rectangle-8-Copy-2"
                  fill="#C6C9D5"
                  x="5.41666667"
                  y="13.8125"
                  width="4.33333333"
                  height="1.0625"
                  rx="0.53125"
                />
                <rect
                  id="Rectangle-8"
                  fill="#47506B"
                  x={0}
                  y="5.3125"
                  width="4.33333333"
                  height="2.125"
                  rx={1}
                />
                <rect
                  id="Rectangle-8"
                  fill="#47506B"
                  x="5.41666667"
                  y="5.3125"
                  width="4.33333333"
                  height="2.125"
                  rx={1}
                />
                <rect
                  id="Rectangle-8"
                  fill="#47506B"
                  x="10.8333333"
                  y="5.3125"
                  width="4.33333333"
                  height="2.125"
                  rx={1}
                />
                <rect
                  id="Rectangle-8"
                  fill="#47506B"
                  x="16.25"
                  y="5.3125"
                  width="4.33333333"
                  height="2.125"
                  rx={1}
                />
              </g>
              <g
                id="Group-11"
                strokeWidth={1}
                fill="none"
                fillRule="evenodd"
                transform="translate(27.000000, 16.000000)"
              >
                <circle id="Oval" fill="#C6C9D5" cx="3.5" cy="3.5" r="3.5" />
                <circle
                  id="Oval"
                  fill="#757D99"
                  opacity="0.7"
                  cx="7.95454545"
                  cy="3.5"
                  r="3.5"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Payment;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/Payment.svg.jsx